import React from 'react'
import { Outlet } from 'react-router-dom';
import { useGetCollaborationDataQuery } from '../../services/collab-proposition/CollabProposition';
import { useGetAllClientsQuery } from '../../services/kmt/cipClient';


function CollaborationCenterLayout() {
    const { data: collaborationData, isLoading: isFetchingCollData } = useGetCollaborationDataQuery();
    const { data: allClients, isLoading: isClientLoading } = useGetAllClientsQuery();
    const collaborationContext = { collaborationData, allClients }
    if (isFetchingCollData || isClientLoading) return null
    return (
        <div className='CollaborationCenterLayout'>
            <Outlet context={collaborationContext} />
        </div>
    )
}

export default CollaborationCenterLayout